<template>
  <div class="w-full px-6 py-4">
    <div class="w-full flex items-center justify-between mb-2 pb-2 border-b">
      <p class="text-sm text-gray-700 font-semibold dark:text-gray-200">
        {{ $t('general.employee') }}
      </p>
      <p class="text-sm text-gray-700 font-semibold dark:text-gray-200">
        {{ $t('components.voucher.edit.employee.enabled') }}
      </p>
    </div>
    <div
      class="w-full flex items-center justify-between mb-2 pb-2 border-b"
    >
      <p class="text-sm font-medium" :class="_all ? 'text-gray-700 dark:text-gray-200' : 'text-gray-300 dark:text-gray-600'">
        {{ $t('components.voucher.edit.employee.enableDisable') }}
      </p>
      <toggle-field v-model="_all" />
    </div>
    <div
      v-for="employee in employees"
      :key="employee.idEmployee"
      class="w-full flex items-center justify-between mb-2 pb-2 border-b"
    >
      <p class="text-sm" :class="_voucher.employeeIDs.includes(employee.idEmployee) ? 'text-gray-700 dark:text-gray-200' : 'text-gray-300 dark:text-gray-600'">
        {{ employee.displayName }}
      </p>
      <toggle-field v-model="_voucher.employeeIDs" :value="employee.idEmployee" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'

import {
  ToggleField,
} from '@/components/fields'

import { useEmployeeStore } from '~/stores/useEmployeeStore'

interface Props {
  voucher: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:voucher', value: Record<string, any>): void
}>()

const employeeStore = useEmployeeStore()

const _voucher = computed({
  get () {
    return props.voucher
  },
  set (value) {
    emit('update:voucher', value)
  },
})

const employees = computed(() => employeeStore.employeesTypeEmployee)

const ids = computed(() => {
  return employees.value.map(({ idEmployee }: any) => idEmployee)
})

const _all = computed({
  get () {
    return ids.value.every((id: any) => _voucher.value.employeeIDs.includes(id))
  },
  set (value: boolean) {
    if (value) {
      _voucher.value.employeeIDs = ids.value
    } else {
      _voucher.value.employeeIDs = []
    }
  },
})

onMounted(() => {
  employeeStore.sync()
})
</script>
